import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class ModProductList extends ModuleComponent {

    ready(){
        super.ready();

        let selectedMaterialId = null;
        let selectedBrandId = null;
        let selectedCollectionId = null;
        let endpoint = '';
        let params = null;
        let filterType= this.$root.data("default-filter");
        let isMaterialSection= this.$root.data("is-section");

        this.viewMore = document.getElementById('viewmore');
        const productsDiv = document.getElementById('products');

        // Filtrar por material
        const materialSpans = document.querySelectorAll(this.scope + '__filter-material');
        if (materialSpans.length) {
            selectedMaterialId = materialSpans[0].getAttribute('data-material');
            materialSpans.forEach(span => {
                span.addEventListener('click', function () {
                    materialSpans.forEach(s => s.classList.remove('active'));
                    span.classList.add('active');
                    selectedMaterialId = span.getAttribute('data-material');
                    deactivateOtherFilters('material');

                    endpoint = `/web/web-product/filter-web-product-by-material`;
                    params = { webMaterialId: selectedMaterialId, isMaterialSection: isMaterialSection };
                    filterType=1;

                    filterProducts();
                }.bind(this));
            });
        }

        // Filtrar por marca
        const brandSpans = document.querySelectorAll(this.scope + '__filter-brand');
        if (brandSpans.length) {
            selectedBrandId = brandSpans[0].getAttribute('data-brand');
            brandSpans.forEach(span => {
                span.addEventListener('click', function () {
                    brandSpans.forEach(s => s.classList.remove('active'));
                    span.classList.add('active');
                    selectedBrandId = span.getAttribute('data-brand');
                    deactivateOtherFilters('brand');

                    endpoint = `/web/web-product/filter-web-product-by-brand`;
                    params = { webBrandId: selectedBrandId };
                    filterType=2;

                    filterProducts();
                }.bind(this));
            });
        }

        // Filtrar por colección
        const collectionSpans = document.querySelectorAll(this.scope + '__filter-collection');
        if (collectionSpans.length) {
            selectedCollectionId = collectionSpans[0].getAttribute('data-collection');
            collectionSpans.forEach(span => {
                span.addEventListener('click', function () {
                    collectionSpans.forEach(s => s.classList.remove('active'));
                    span.classList.add('active');
                    selectedCollectionId = span.getAttribute('data-collection');
                    deactivateOtherFilters('collection');

                    endpoint = `/web/web-product/filter-web-product-by-collection`;
                    params = { webCollectionId: selectedCollectionId };
                    filterType=3;

                    filterProducts();
                }.bind(this));
            });
        }

        // Desactivar el resto de filtros
        const deactivateOtherFilters = (activeFilterType) => {
            if (activeFilterType !== 'material') {
                const materialSpans = document.querySelectorAll(this.scope + '__filter-material');
                materialSpans.forEach(s => s.classList.remove('active'));
            }
            if (activeFilterType !== 'brand') {
                const brandSpans = document.querySelectorAll(this.scope + '__filter-brand');
                brandSpans.forEach(s => s.classList.remove('active'));
            }
            if (activeFilterType !== 'collection') {
                const collectionSpans = document.querySelectorAll(this.scope + '__filter-collection');
                collectionSpans.forEach(s => s.classList.remove('active'));
            }
        };

        this.findMember('view-more-button').click(
            (ev) => {
                ev.preventDefault();
                GvfService.endpoint(
                    `/web/web-product/view-all-products`,
                    {
                        filterType: filterType,
                        webMaterialId: selectedMaterialId,
                        webBrandId: selectedBrandId,
                        webCollectionId: selectedCollectionId
                    },
                ).then(
                    (resp) => {
                        if (resp.html) {
                            productsDiv.innerHTML = resp.html;
                            GvfUiService.init(this.$root);
                        }
                        this.viewMore.style.display = "none";
                    }
                );
            }
        );

        const filterProducts = () => {
            if (!params) return;
            GvfService.endpoint(
                endpoint,
                params
            ).then(
                (resp) => {
                    if (resp.html) {
                        productsDiv.innerHTML = resp.html;
                        GvfUiService.init($(resp.html));
                    }
                    if (resp.count < 5) {
                        this.viewMore.style.display = "none";
                    } else {
                        this.viewMore.style.display = "block";
                    }
                }
            );
        };
    }
}
